import React from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VerifiedUserSharpIcon from "@mui/icons-material/VerifiedUserSharp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessFinalNocModal = ({
  isConfirmationFLOpen,
  setIsConfirmationFLOpen,
  setOpenSlider,
  onSuccessClose,
}: {
  isConfirmationFLOpen: boolean;
  setIsConfirmationFLOpen: (open: boolean) => void;
  setOpenSlider: (open: boolean) => void;
  onSuccessClose?: () => void;
}) => {
  const handleYesClick = () => {
    setOpenSlider(false);
    setIsConfirmationFLOpen(false);
    // if (onSuccessClose) onSuccessClose(); // ✅ call after closing
  };

  return (
    <Dialog
      open={isConfirmationFLOpen}
      onClose={handleYesClick} // ✅ call handleYesClick here too
      maxWidth={false}
      fullWidth={false}
      sx={{
        "& .MuiDialog-paper": {
          width: "400px",
          maxWidth: "400px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: "1.25rem",
          position: "relative",
          pb: 1,
        }}
      >
        Final NOC Request
        <IconButton
          aria-label="close"
          onClick={handleYesClick} // ✅ close via top-right icon
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          borderBottom: "none",
          borderTop: "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "left", mb: 3 }}>
          <VerifiedUserSharpIcon sx={{ fontSize: 64, color: "#43B864" }} />
        </Box>
        <Typography sx={{ fontSize: "1.2rem", fontWeight: 700, mb: 2 }}>
          Request Raised For Final NOC Successfully
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          sx={{
            borderRadius: "24px",
            backgroundColor: "#3A1C73",
            textTransform: "none",
            fontWeight: 500,
            width: "100%",
            marginBottom: 1,
            "&:hover": { backgroundColor: "#2a145c" },
          }}
          onClick={handleYesClick}
        >
          OK, Got it.
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessFinalNocModal;
